var React = require('react');

function Ai (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M27.693,24.516h3.445l0.929,3.088h2.927l-3.731-12.031h-3.57l-3.677,12.031h2.82L27.693,24.516z M28.799,19.928    c0.196-0.696,0.375-1.606,0.554-2.32h0.035c0.179,0.714,0.394,1.607,0.608,2.32l0.75,2.553h-2.66L28.799,19.928z","key":0}),React.createElement("rect",{"x":"36.428","y":"15.572","width":"2.731","height":"12.031","key":1}),React.createElement("rect",{"x":"15","y":"39.165","width":"34","height":"2","key":2}),React.createElement("rect",{"x":"15","y":"45.068","width":"34","height":"2","key":3}),React.createElement("rect",{"x":"15","y":"50.972","width":"34","height":"2","key":4})]));
}

Ai.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 64 64","enableBackground":"new 0 0 64 64","xmlSpace":"preserve"};

module.exports = Ai;

Ai.default = Ai;
